import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  public notification;
  constructor (private http: HttpClient) { }

  saveUserInfo (trans) {
    // console.log("[Notifications service data ", trans);
    return this.http.post('/edozzier/portal-save-notification-info.php', trans);
  }
  addPushSubscriber (sub: any) {
    return this.http.post('/edozzier/notifications/vendor/minishlink/web-push/src/notify.php', sub);
  }
  saveEndpoint (data: any) {
    return this.http.post('/edozzier/portal-save-notification-info.php', data);
  }

  notificationMessage (message) {
    this.notification = message;
    // console.log('servie', this.notification.notification);
    return this.notification;
  }

  showNotifications (matric) {
    return this.http.post('/edozzier/portal-show-notifications.php', matric);
  }

  get _notification () {
    return this.notification.notification;
  }

  getAllNoticeFromNoticeBoard (params = {}) {
    return this.http.get('/edozzier/portal-getAllNoticeFromNoticeBoard.php', { params });
  }
}
